import React from 'react';
import '../../styles/components/AsperaBrandingForm.scss';
import { AsperaWrapper } from '../AsperaWrapper';
import { AsperaForm } from '../AsperaForm';
import { language } from '../../services/LanguageService';
import { SubManager } from '../../classes/SubManager';
import { Button, getIconComponent } from '../Carbon';
import { AsperaImagePicker } from '../AsperaImagePicker';
import { brandingLoginBackground, brandingLoginCenterAlignImage, brandingLoginImage, brandingLoginLeftAlignImage } from '../../constants/data';
import { getTextImageTooltip } from '../../components/AsperaBrandingForm';
import { createImageUrl } from '../../helpers/starterHelpers';
import { Subject } from 'rxjs';
/**
 * React Component
 *
 * The AsperaLoginCustomForm renders custom login form. Load directly on component.
 *
 * @example
 * ```javascript
 * <AsperaLoginCustomForm onSubmit={() => {}} />
 * ```
 */
export class AsperaLoginCustomForm extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: true,
            error: false,
            showAnnouncementTwo: false,
        };
        this.subManager = new SubManager();
        this.localModel = {};
        this.externalDirtySubject = new Subject();
        this.save = () => {
            const { onSubmit } = this.props;
            onSubmit(this.localModel);
        };
        this.changeRadioLayout = (type) => {
            this.localModel.layout = type;
            this.externalDirtySubject.next(true);
            this.setState({});
        };
    }
    get previewLoginPageButton() {
        const { previewLoginPageCallback } = this.props;
        if (typeof previewLoginPageCallback === 'function') {
            return React.createElement(Button, { kind: "primary", className: "branding-preview-button", renderIcon: getIconComponent('View'), iconDescription: language.get('customBrandingForm.previewLoginPage'), onClick: () => previewLoginPageCallback(this.localModel) }, language.get('customBrandingForm.previewLoginPage'));
        }
        return null;
    }
    get formDetails() {
        const { previewLoginPageCallback, disableNewLoginPageFeatures, openThemeEditor, customLogoHelper, customBackgroundHelper } = this.props;
        const { showAnnouncementTwo } = this.state;
        if (!this.localModel.layout) {
            this.localModel.layout = 'LEFT';
        }
        return {
            model: this.localModel,
            id: 'aspera-form-login-form-container',
            onSubmit: this.save,
            items: [
                { type: 'custom', hidden: () => !previewLoginPageCallback, customView: this.previewLoginPageButton },
                { type: 'sub-header', hidden: () => !!disableNewLoginPageFeatures, label: language.get('customBrandingForm.layout') },
                {
                    type: 'radio',
                    pointer: 'layout',
                    hidden: () => !!disableNewLoginPageFeatures,
                    label: language.get('customBrandingForm.loginScreenLayout'),
                    radioProps: { orientation: 'horizontal' },
                    items: [
                        {
                            value: 'LEFT',
                            text: language.get('customBrandingForm.leftAligned'),
                        },
                        {
                            value: 'CENTER',
                            text: language.get('customBrandingForm.centerAligned'),
                        },
                    ],
                },
                {
                    type: 'custom',
                    hidden: () => !!disableNewLoginPageFeatures,
                    customView: React.createElement("div", { className: "radio-imagery" },
                        React.createElement("img", { src: brandingLoginLeftAlignImage, alt: language.get('customBrandingForm.leftAligned'), title: language.get('customBrandingForm.leftAligned'), onClick: () => this.changeRadioLayout('LEFT') }),
                        React.createElement("img", { src: brandingLoginCenterAlignImage, alt: language.get('customBrandingForm.centerAligned'), title: language.get('customBrandingForm.centerAligned'), onClick: () => this.changeRadioLayout('CENTER') })),
                },
                {
                    type: 'custom',
                    collapseGroup: true,
                    customView: (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "image-label" }, language.get('customBrandingForm.customLogo')),
                        getTextImageTooltip(customLogoHelper ? customLogoHelper : language.get('customBrandingForm.customLogoHelperDefault'), language.get('customBrandingForm.customLogoHere'), brandingLoginImage),
                        React.createElement(AsperaImagePicker, { onChange: data => {
                                this.localModel.loginPageLogo = data;
                                this.externalDirtySubject.next(true);
                            }, initialData: createImageUrl(this.localModel.loginPageLogo), renderWidth: 160, renderHeight: 125, maxSize: 500000 }))),
                },
                {
                    type: 'custom',
                    collapseGroup: true,
                    customView: (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "image-label" }, language.get('customBrandingForm.customBackgroundImage')),
                        getTextImageTooltip(customBackgroundHelper ? customBackgroundHelper : language.get('customBrandingForm.customBackgroundImageHelperDefault'), language.get('customBrandingForm.customBackgroundHere'), brandingLoginBackground),
                        React.createElement(AsperaImagePicker, { onChange: data => {
                                this.localModel.loginPageBackground = data;
                                this.externalDirtySubject.next(true);
                            }, initialData: createImageUrl(this.localModel.loginPageBackground), renderWidth: 380, renderHeight: 220, maxSize: 4000000 }))),
                },
                {
                    type: 'select',
                    hidden: () => { var _a, _b; return disableNewLoginPageFeatures || !(((_a = this.localModel.loginPageBackground) === null || _a === void 0 ? void 0 : _a.body) || ((_b = this.localModel.loginPageBackground) === null || _b === void 0 ? void 0 : _b.initialData)); },
                    label: language.get('customBrandingForm.customBackgroundPosition'),
                    helperText: language.get('customBrandingForm.customBackgroundPositionHelper'),
                    pointer: 'loginPageBackgroundPosition',
                    selectDefaultText: language.get('customBrandingForm.centerBottom'),
                    items: [
                        { value: 'center center', text: language.get('customBrandingForm.centerCenter') },
                        { value: 'center top', text: language.get('customBrandingForm.centerTop') },
                        { value: 'left bottom', text: language.get('customBrandingForm.leftBottom') },
                        { value: 'left center', text: language.get('customBrandingForm.leftCenter') },
                        { value: 'left top', text: language.get('customBrandingForm.leftTop') },
                        { value: 'right bottom', text: language.get('customBrandingForm.rightBottom') },
                        { value: 'right center', text: language.get('customBrandingForm.rightCenter') },
                        { value: 'right top', text: language.get('customBrandingForm.rightTop') },
                    ],
                },
                { type: 'sub-header', hidden: () => !!disableNewLoginPageFeatures, label: language.get('customBrandingForm.announcementPanel'), helperText: language.get('customBrandingForm.announcementPanelHelper') },
                {
                    type: 'text',
                    pointer: 'announcementOneTitle',
                    hidden: () => !!disableNewLoginPageFeatures,
                    label: language.get('customBrandingForm.announcementOne'),
                    placeholder: language.get('customBrandingForm.announcement'),
                },
                {
                    type: 'textarea',
                    pointer: 'announcementOneMessage',
                    hidden: () => !!disableNewLoginPageFeatures,
                    label: language.get('customBrandingForm.announcementOneMessage'),
                },
                {
                    type: 'custom',
                    hidden: () => !!disableNewLoginPageFeatures || showAnnouncementTwo,
                    customView: React.createElement(Button, { kind: "tertiary", onClick: () => this.setState({ showAnnouncementTwo: true }) }, language.get('customBrandingForm.addAdditionalPanel')),
                },
                {
                    type: 'text',
                    pointer: 'announcementTwoTitle',
                    hidden: () => !!disableNewLoginPageFeatures || !showAnnouncementTwo,
                    label: language.get('customBrandingForm.announcementTwo'),
                    placeholder: language.get('customBrandingForm.announcement'),
                },
                {
                    type: 'textarea',
                    pointer: 'announcementTwoMessage',
                    hidden: () => !!disableNewLoginPageFeatures || !showAnnouncementTwo,
                    label: language.get('customBrandingForm.announcementTwoMessage'),
                },
                {
                    type: 'sub-header',
                    hidden: () => !!disableNewLoginPageFeatures || !openThemeEditor,
                    label: language.get('customBrandingForm.customizeLoginTheme'),
                    helperText: language.get('customBrandingForm.customizeLoginThemeHelper'),
                },
                {
                    type: 'custom',
                    collapseGroup: true,
                    hidden: () => !!disableNewLoginPageFeatures || !openThemeEditor,
                    customView: React.createElement(Button, { kind: "tertiary", onClick: openThemeEditor, renderIcon: getIconComponent('ArrowRight') }, language.get('customBrandingForm.customizeTheme')),
                },
            ],
        };
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    componentDidMount() {
        const { value } = this.props;
        this.localModel = value;
        this.setState({ loading: false, showAnnouncementTwo: !!(value.announcementTwoMessage || value.announcementTwoTitle) });
    }
    render() {
        const { className } = this.props;
        const { loading, error } = this.state;
        const id = 'aspera-login-custom-form';
        return (React.createElement(AsperaWrapper, { className: `aspera-login-custom-form aspera-branding-form ${className ? className : ''}`, loading: loading, error: error, id: id, disableWrapping: true },
            React.createElement(AsperaForm, { externalDirty: this.externalDirtySubject.asObservable(), formDetails: this.formDetails, fullPageWrapperId: id })));
    }
}
